<script>
export default {
  methods: {
    $verifyDates(dates){ //{debut = 'date', fin = 'date'}
      if (dates.debut !== '' && dates.fin !== '' && dates.debut != null && dates.fin != null && dates.debut != undefined && dates.fin != undefined){
        let d1 = new Date(dates.debut), d2 = new Date(dates.fin);
        return d1 <= d2;
      }else {
        return true;
      }
    },
    badDates(){
      window.alert('La date de début doit être antérieure à la date de fin.');
    },
  },
};
</script>
